module.exports = __webpack_public_path__ + "img/germany.dad155d8.svg";